import React from 'react';
import { Container } from '@chakra-ui/react';

const Wrapper = ({
  px = { base: 6, md: 14 },
  narrow = false,
  medium = false,
  full = false,
  children,
  ...props
}) => {
  // Calculate the max width.
  let maxWidth;
  switch (true) {
    case narrow:
      maxWidth = `62rem`;
      break;
    case medium:
      maxWidth = `80rem`;
      break;
    case full:
      maxWidth = `none`;
      break;
    default:
      maxWidth = `90rem`;
  }

  return (
    <Container px={px} mx="auto" width="100%" maxW={maxWidth} {...props}>
      {children}
    </Container>
  );
};

export default Wrapper;
